import React, { useEffect, useState } from "react";
import moment, { Moment } from "moment";
// import { useSelector } from "react-redux";
import { Chart as ChartJS, CategoryScale, ArcElement, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';

import { useAppDispatch } from "../../../../redux/store";
import { LoadingSpinner } from "../../../../components/ui/loadinSpinner";
import DataRangeSelector from "../../../../components/dataRangeSelector";
// import StackedBarChart from "../../../../components/charts/stackedBarChart";
import { getHospitalsPatientTypeOccupiedGraphData, getOverAllBedOccupancy } from "../../../../redux/mis/misReducer";
// import { RootState } from "../../../../redux/store";
// import { Box } from "@mui/material";
import { Bar } from "react-chartjs-2";
import { useQueries } from "@tanstack/react-query";
// import StackedBarChart from "../../../../components/charts/stackedBarChart";
// import { ChartOptions } from "chart.js";


ChartJS.register(ArcElement, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

// interface OccupiedBedItem {
//     patientType: string;
//     location: string;
//     month: string;
//     year: number;
//     occupiedBeds: number;
// }

function InPatientOccupied({
    country,
    state,
    district,
    taluk,
    hobli,
    serviceType,
    filterApplyToggle,
    title,
    hospitalId,
    patientType
}: {
    country: string;
    state: string;
    district: string;
    taluk: string;
    hobli: string;
    serviceType: number;
    filterApplyToggle: boolean;
    title?: string;
    hospitalId?: any;
    patientType?: any;
}) {
    const dispatch = useAppDispatch();

    const currentDate = new Date();
    const currentMonth = moment(currentDate).month(); // 0-indexed: 0 = Jan, 3 = Apr

    let financialYearStart;

    // If current month is Jan, Feb, or Mar, the financial year started in the previous calendar year
    if (currentMonth < 3) {
        financialYearStart = moment(currentDate).subtract(1, 'year').month(3).startOf('month');
    } else {
        // Otherwise, it started in April of the current calendar year
        financialYearStart = moment(currentDate).month(3).startOf('month');
    }

    // The financial year ends on March 31st of the following calendar year from the start
    const currentYearStart = financialYearStart;
    const currentYearEnd = moment(financialYearStart).add(11, 'months').endOf('month');
    const [fromDate, setFromDate] = useState<Moment>(
        currentYearStart
    );
    const [toDate, setToDate] = useState<Moment>(currentYearEnd);

    // const { data, isLoading } = useSelector(
    //     (state: RootState) => state.occupiedBedGraph
    // );
    console.log(hospitalId, "hospitalId")
    const [{ data, isLoading }] = useQueries({
        queries: [
            {
                queryKey: ["getOverAllBedOccupancy", fromDate, toDate, hospitalId, patientType],
                queryFn: () => getOverAllBedOccupancy(fromDate, toDate, hospitalId, "1", patientType)
            },
        ],
    });
    useEffect(() => {
        dispatch(
            getHospitalsPatientTypeOccupiedGraphData({
                country,
                state,
                district,
                taluk,
                hobli,
                serviceType,
                fromDate: moment(fromDate).format("YYYY-MM-DD"),
                toDate: moment(toDate).format("YYYY-MM-DD"),
            })
        );
    }, [fromDate, toDate, filterApplyToggle]);
    // const chartData = useMemo(() => {
    //     if (!data.length) return { labels: [], datasets: [] };

    //     // Generate all month-year labels between fromDate and toDate
    //     const start = moment(fromDate);
    //     const end = moment(toDate);
    //     const labels: string[] = [];

    //     const current = start.clone();
    //     while (current.isSameOrBefore(end, "month")) {
    //         labels.push(current.format("MMM YYYY")); // e.g., "Jan 2025"
    //         current.add(1, "month");
    //     }

    //     // Unique locations (ICU, Ward, etc.)
    //     const locations = Array.from(new Set(data.map(d => d.location)));

    //     const datasets = locations.map((location, index) => {
    //         const values = labels.map(label => {
    //             const [month, year] = label.split(" ");

    //             const record = data.find(
    //                 d =>
    //                     d.location === location &&
    //                     d.month === month &&
    //                     d.year === Number(year)
    //             );

    //             return record?.occupiedBeds ?? 0; // fill missing months with 0
    //         });

    //         const total = values.reduce((a, b) => a + b, 0);

    //         return {
    //             label: `${location} (${total})`,
    //             data: values,
    //             backgroundColor: [
    //                 "#4FD1C5",
    //                 "#F6AD55",
    //                 "#90CDF4",
    //                 "#FC8181",
    //                 "#D6BCFA",
    //             ][index % 5],
    //             borderWidth: 1,

    //             // barThickness: 28,
    //             // maxBarThickness: 28,
    //             // categoryPercentage: 0.8,
    //             // barPercentage: 0.9,
    //         };
    //     });

    //     return { labels, datasets };
    // }, [data, fromDate, toDate]);


    // import { ChartOptions } from "chart.js";

    const stackedBarChartoptions: any = {
        responsive: true,
        maintainAspectRatio: false,
        barPercentage: 0.8, // ✅ Adjusts bar width
        categoryPercentage: 0.6, // ✅ Adds small gap between stacked bars
        plugins: {
            legend: {
                display: true,
                position: 'bottom',
                labels: {
                    usePointStyle: true,
                    boxWidth: 10,
                    pointStyleWidth: 14, // increases space between circle and label
                    padding: 20
                },
            },
            tooltip: {
                callbacks: {
                    label: (tooltipItem: any) => `${tooltipItem.dataset.label}: ${tooltipItem.raw}`,
                },
            },
        },
        scales: {
            x: {
                stacked: true,
                ticks: { color: '#666' },
                grid: { drawOnChartArea: false },
            },
            xYears: {
                position: 'bottom',
                ticks: {
                    callback: function (/* value: any, */ index: number) {
                        return index === 0 ? '2022' : index === 8 ? '2023' : ''; // ✅ Show years below months
                    },
                    font: { weight: 'bold' },
                    color: '#666',
                },
                grid: { drawOnChartArea: false },
            },
            y: {
                stacked: true,
                title: {
                    display: true,
                    text: 'Occupied Bed Days',
                },
            },
        },
    };

    return (
        <div className="p-4 bg-white shadow-sm border rounded-lg w-full pb-20">
            <div className="flex justify-between pb-3">
                <span className="text-18 font-medium text-primary">
                    {title}
                </span>
                {/* {Counter()} */}
                <DataRangeSelector
                    fromDate={fromDate}
                    setFromDate={setFromDate as any}
                    toDate={toDate}
                    setToDate={setToDate as any}
                    py="py-[8px]"
                    border="border-gray-300"
                    borderRadius="rounded-lg"
                    shadow
                    position="right-0"
                />
            </div>

            {isLoading ? (
                <div className="flex justify-center items-center h-full">
                    <LoadingSpinner />
                </div>
            ) : data ? (
                // <Box>
                <Bar data={data} options={data.options ? data.options : stackedBarChartoptions} />
                // </Box>
            ) : (
                <div className="flex justify-center items-center h-full">
                    <span className="text-18 font-medium text-primary">
                        No Data Found
                    </span>
                </div>
            )}
        </div>
    );
}

export default InPatientOccupied;
